import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import OnlineOnboardingBanner from '../../components/online-onboarding-banner';
import OnlineOnboardingContent from '../../components/online-onboarding-content';

const _OnlineOnboarding = () => {
  const [currentStep, setCurrentStep] = useState(null); // Zmeniť z 0 na null

  return (
    <>
      <OnlineOnboardingBanner currentStep={currentStep} />
      <OnlineOnboardingContent
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userType: state.user.type,
  };
};

const OnlineOnboarding = withRouter(connect(mapStateToProps)(_OnlineOnboarding));

export default OnlineOnboarding;
